import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormatValueConversionModule } from '@y42/core/format-value-conversion';
import { IconModule } from '@y42/core/icon';
import { DateTimeModule } from '@y42/date-time';
import { JobTriggeredByUserAvatarModule } from '../job-triggered-by-user-avatar';
import { JobInfoContentModule } from './job-info-content/job-info-content.module';
import { JobInfoHostDirective } from './job-info-host.directive';
import { JobInfoComponent } from './job-info.component';

@NgModule({
  declarations: [JobInfoComponent, JobInfoHostDirective],
  imports: [
    CommonModule,
    IconModule,
    DateTimeModule,
    MatExpansionModule,
    JobTriggeredByUserAvatarModule,
    FormatValueConversionModule,
    JobInfoContentModule,
  ],
  exports: [JobInfoComponent, JobInfoHostDirective],
})
export class JobInfoModule {}
